   <template>
  
        <div class="container py-4">
          <!--           -->   
      <div class="card shadow-lg border rounded-4    transition-card ">
        <div class="card-body text-center p-4">
           <slot name="image" :object="object"></slot>

              <router-link
             :to="object.link"
            class="title-link"
          >
          <h3 class="text-success fw-bold mb-3">{{ object.title }}</h3>
               </router-link>
          <div class="fs-6 mb-3 lh-md"   v-html="object.description">
        
          </div>
        </div>
      </div>
    </div>

      

</template>


<script>


export default {
  props: ['object'],
 
  
  methods: {}
};
</script>


<style scoped>

.card {
  /*border: 4px solid olive ; light green background  #d4eadd*/
  background-color: white; /* light green background  #f9fdfb*/
 
}

.title-link {
  text-decoration: none;
}

.title-link:hover h3 {
  text-decoration: underline;
}

.transition-card {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  /*  //border-left: 5px solid #198754;Bootstrap green */
}

.transition-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
 /* background-color: lightgrey;  #f9fdfb;  light green tint on hover */
  color: black; /* #f9fdfb;  light green tint on hover */
  cursor: default;
}

</style>